import GrowthFunnelComponent from '../Components/Growth/GrowthFunnelComponent';

function GrowthFunnelPage() {
  return <GrowthFunnelComponent />;
}

export default GrowthFunnelPage;